export default __webpack_public_path__ + "static/media/Group9416.bcb6e241.svg";